import CouponVM from './coupon-vm';
export default {
  prepUI: function() {
    //TODO
  },
  init : function() {
    var validationOptions = Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS;

    var resource_id = $('#resource_id').val();
    var course_id = $('#course_id').val();
    var hasFields = !!$('#has_enrollment_fields').val();
    var hasCodes = !!$('#has_codes').val();
    ko.applyBindingsWithValidation(new CouponVM(resource_id, course_id, hasFields, hasCodes), document.getElementById('js-resource-coupon-form'), validationOptions);
  }
};
